import React, { useState } from 'react';
import { Container } from "reactstrap"
import '../assests/css/Login.css'
import { useHistory } from "react-router-dom";
import '../assests/css/Login.css'
import OtpInput from 'react-otp-input';
import verifyOtpApi from '../services/verifyOtpApi'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IdleMonitor from './userAutoLogout'; //session management
import forgotPwdApi from '../services/forgotPwd';
import resendOtpApi from '../services/resendOtpApi';
const VerifyOtp = (props) => {
    const history = useHistory();
    const [otp, setOtp] = useState('');
    const [disButton, setDisButton] = useState(false)
    const [disButtonotp, setDisButtonotp] = useState(false)
    const [disButtonotp1, setDisButtonotp1] = useState(false)

    const toastId = React.useRef(null);

    const handleChange = (otp) => {
        setOtp(otp);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (otp.length === 6) {
            setDisButton(true);
            const userEmail = localStorage.getItem('email');
            var submitData = {
                "userId": userEmail,
                "code": otp
            }
            // console.log("submitData", submitData)
            var res = await verifyOtpApi(submitData, history, props.location.type, toast, setDisButton)
        
        } else {
            if(! toast.isActive(toastId.current)) {
                toastId.current = toast.warning(`Please fill all the fields!`);
              } 
              
        }
    }

    const onSubmitOTP = () => {
    
          var data = {
              "userId": localStorage.getItem('userEmail')
          }
      
          setDisButtonotp(true);
        forgotPwdApi(data).then(res => {
            console.log("data", data);

            console.log("request",res)
            if (res.success === "true") { 
                console.log("Verified successfully", res.data)
                setDisButtonotp(false);

                history.push({
                    pathname : '/verify-otp',
                    type : true
                });
            }
            else {
                // console.log("Verification failed", res)
                toast.error("User Not Exist!")
            //    reset(register);
            setDisButtonotp(false);
            }
        });
    }
    const onSubmitVerificationOTP = () => {
        //   localStorage.setItem('userEmail', JSON.stringify(data.userId));
          //   const userEmail = localStorage.getItem("userEmail");
            // console.log("useremail",userEmail)
      //      alert("hello")
      if(localStorage.getItem('verification')){
        var data = {
            "userId": localStorage.getItem('email_verification')
        }
      }else{
             var data = {
                 "userId": localStorage.getItem('email')
             }
            }
             setDisButtonotp1(true);
             resendOtpApi(data).then(res => {
               console.log("data", data);
   
               console.log("request",res)
               if (res.success === "true") { 
                   console.log("Verified successfully", res.data)
                   setDisButtonotp1(false);
   
                   history.push({
                       pathname : '/verify-otp',
                       type : true
                   });
               }
               else {
                   // console.log("Verification failed", res)
                   toast.error("User Not Exist!")
               //    reset(register);
               setDisButtonotp1(false);
               }
           });
       }



    return (
        <div className="maindiv">
            <Container fluid={true} style={{alignItems: "center", justifyContent: "center", display: "flex"}}>
                        <div className="text-center bg-white middleDiv">
                            <div className="innerDiv rounded">
                                <img src="LocusB.png" alt="logo" className="logo" />
                                <div className="text-center mb-1">
                                    <h6>Please enter 6 digit verification code sent to your email address</h6>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <OtpInput
                                        containerStyle={{ placeContent: "center", margin: "30px" }}
                                        inputStyle={{ width: "2em", margin: "2px", height: "2.5em" }}
                                        value={otp}
                                        onChange={handleChange}
                                        numInputs={6}
                                        separator={<span>&nbsp;</span>}
                                        isInputNum={true}
                                        shouldAutoFocus={true}
                                    />
                                    <h6>Please allow 1 to 2 minutes to receive it</h6>
                                    <button type="submit" disabled={disButton} className="btnDesg my-2">
                                        {disButton ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Verify"}
                                    </button>
                                 
                                </form>
                           {localStorage.getItem('forget')?
                        //    <button  disabled={disButtonotp} className="btnDesg my-2" onClick={onSubmitOTP}>
                        //                 {disButtonotp ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Resend code"}
                        //             </button>
                        <small className="belowBtn">Didn't get any email? <a onClick={onSubmitOTP} ><span><b style={{cursor: "pointer"}}>Resend code</b></span></a></small>

                                    :
                                    // <button  disabled={disButtonotp1} className="btnDesg my-2" onClick={onSubmitVerificationOTP}>
                                    //     {disButtonotp1 ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Resend code"}
                                    // </button>
                                    <small className="belowBtn">Didn't get any email? <a onClick={onSubmitVerificationOTP} ><span><b style={{cursor: "pointer"}}>Resend code</b></span></a></small>
    
                                    }
                                <ToastContainer />
                            </div>
                        </div>
            </Container>
            <IdleMonitor/>
        </div>
    );
}

export default VerifyOtp;